'use strict';

const trackingUtils = require('../modules/utils/tracking.utils');
const inputPatterns = require('../modules/utils/input_pattern_utils');
const fieldUtils = require('../modules/utils/field.utils');

Odigeo.defineWidget('special_request_manager', Odigeo.Widget.extend({
    modelClass: Odigeo.Model.extend({
        defaults: {
            option: '',
            bookingUserComments: '',
        },
        validate() {
            const option = this.get('specialRequestOption');
            return option === 'wheelchair' ? !Odigeo._.isEmpty(this.get('pmiBatteryType')) && !Odigeo._.isEmpty(this.get('pmiOption')) : true;
        },
        hasSpecialRequest() {
            return this.get('specialRequestDisplay') && !Odigeo._.isEmpty(this.get('specialRequestOption'));
        },
        getData() {
            const option = this.get('specialRequestOption');
            const attrDataMap = {
                wheelchair: ['pmiType', 'pmiOption', 'pmiBatteryType'],
                pets: ['petsOption', 'petsWeight', 'petsLength', 'petsWidth'],
            };
            return this.getStringData(attrDataMap[option] ? attrDataMap[option] : []);
        },
        getStringData(attrList) {
            return Odigeo._.reduce(attrList, Odigeo._.bind(function(result, value) {
                return result + '-' + this.get(value);
            }, this), Odigeo._.snakeCase(this.get('specialRequestOption')));
        },
    }),
    viewClass: Odigeo.View.extend({
        selectors: {
            optionsContainer: '.options_container',
            specialRequestForm: '.special_request_form',
            displaySpecialRequestSelector: '#specialRequestDisplay',
            specialRequestOption: '[data-name="specialRequestOption"]',
            wheelchairFields: 'select[data-name="pmiBatteryType"], select[data-name="pmiOption"]',
            petInputFields: 'input[data-name="petsWeight"], input[data-name="petsLength"], input[data-name="petsWidth"]',
            fields: 'input, radio, select',
            clearInput: '.clear_input',
        },
        events: {
            'change @displaySpecialRequestSelector': 'toggleForm',
        },
        init() {
            this.form = Odigeo.UIElements.collapsive.enhance(this.$cachedSelectors.specialRequestForm, {initiallyExpanded: false});
            this.bindEvents();
            this.$cachedSelectors.fields.trigger(Odigeo.Events.change);
        },
        bindEvents() {
            this.$cachedSelectors.specialRequestOption.on(Odigeo.Events.change, Odigeo._.bind(this.onOptionSelectedChanged, this, _));
            this.$cachedSelectors.fields.on(Odigeo.Events.change, Odigeo._.bind(this.saveFieldValue, this, _));
            Odigeo._.each(this.$cachedSelectors.petInputFields, function($input) {
                inputPatterns.initInputPattern($input);
            });
            this.$cachedSelectors.wheelchairFields.parents().closest('.validation_field').attr('data-state', 'init');
            this.$cachedSelectors.wheelchairFields.on(Odigeo.Events.blur, Odigeo._.bind(this.checkValidity, this, _, false));
            this.$cachedSelectors.petInputFields.parents().closest('.validation_field').attr('data-state', 'init');
            this.$cachedSelectors.petInputFields.on(Odigeo.Events.focus, this.setFocus);
            this.$cachedSelectors.petInputFields.on(Odigeo.Events.blur, Odigeo._.partial(this.checkValidity, _, true));
            this.$cachedSelectors.clearInput.on(Odigeo.Events.tap, fieldUtils.clearField);
        },
        toggleForm() {
            this.form.trigger('togglePanelByParameter', this.$cachedSelectors.displaySpecialRequestSelector.is(':checked'));
        },
        onOptionSelectedChanged(e) {
            const value = e.target.value;
            const prevOption = this.widget.model.get('option');
            const hasTransition = Odigeo._.contains(['pets', 'wheelchair'], prevOption);

            this.widget.model.set('option', value);
            this.$cachedSelectors.optionsContainer.attr('data-selected', hasTransition ? 'transition-' + prevOption : value);
            if (hasTransition) {
                this.$cachedSelectors.optionsContainer.one(Odigeo.Events.transitionEnd, Odigeo._.bind(this.changeDataSelected, this, value));
            }
        },
        changeDataSelected() {
            this.$cachedSelectors.optionsContainer.attr('data-selected', this.widget.model.get('option'));
        },
        saveFieldValue(e) {
            const $field = $(e.target);
            const fieldType = $field.attr('type');

            if (fieldType !== 'radio' || (fieldType === 'radio' && $field.is(':checked') === true)) {
                this.widget.model.set($field.attr('data-name') || $field.attr('name'),
                    fieldType === 'checkbox' ? $field.is(':checked') : e.target.value);
            }
        },
        displayErrors() {
            if (this.model.get('specialRequestOption') === 'wheelchair') {
                Odigeo._.each(this.$cachedSelectors.wheelchairFields, function($field) {
                    fieldUtils.setStateAndShowError($field);
                });
            }
        },
        checkValidity(e, allowsEmpty) {
            fieldUtils.removeFocus(e.target);
            fieldUtils.setStateAndShowError(e.target, true, allowsEmpty);

            const $el = $(e.target);
            const value = $el.val();

            if (Odigeo._.isEmpty(value) ) {
                $el.parents().closest('.validation_field').attr('data-state', 'init');
            }
        },
        setFocus(e) {
            fieldUtils.setFocus(e.target);
        },
    }),
    analyticsEventTracking() {
        const suffixValues = {
            pets: 'pets',
            wheelchair: 'pmr',
            minor: 'underage',
            specialLuggage: 'equipment',
            familyDiscount: 'familydiscount',
            other: 'other',
        };
        const label = 'special_request_' + (suffixValues[this.model.get('option')]);
        if (suffixValues[this.model.get('option')] || suffixValues[this.model.get('option')] !== 'other') {
            trackingUtils.trackEvent('special_requests', label);
        }
    },
    getSpecialRequestData() {
        return this.model.getData();
    },
    isValid() {
        const isValid = this.model.validate();
        if (!isValid) {
            this.view.displayErrors();
        }
        return isValid;
    },
    hasSpecialRequest() {
        return this.model.hasSpecialRequest();
    },
    setBookingUserComments() {
        if (this.hasSpecialRequest() && this.isValid()) {
            Odigeo.Session.set('bookingUserComments', JSON.stringify(this.getSpecialRequestData()));
        }
    },
}));
